module.exports = __webpack_public_path__ + "img/组 47.55e12eb6.png";